import { Injectable } from '@angular/core';
import { OperatorFront } from '../../models/api.models';

@Injectable({
  providedIn: 'root'
})
export class OperatorPopulateService {

  constructor() { }

  public convertOperatorsToOperatorsFront(operators: number[]): OperatorFront[] {
    const operatorsFront: OperatorFront[] = [];
    operators.forEach(operator => {
      const operatorFront = new OperatorFront();
      operatorFront.id = operator;
      operatorFront.operario = 'Operario ' + operator;
      operatorFront.claseOperario = 'operario' + operator;
      operatorsFront.push(operatorFront);
    });
    return operatorsFront;
  }

  public convertOperatorToOperatorFront(operator: number): OperatorFront {
    const operatorFront = new OperatorFront();
    operatorFront.id = operator;
    operatorFront.operario = 'Operario ' + operator;
    operatorFront.claseOperario = 'operario' + operator;
    return operatorFront;
  }

  public convertOperatorFrontToOperator(operatorFront: OperatorFront): number {
    let operator: number;
    operator = operatorFront.id;
    return operator;
  }

  public convertOperatorsFrontToOperators(operatorsFront: OperatorFront[]): number[] {
    const operator: number[] =  [];
    operatorsFront.forEach(operatorFront => {
      operator.push(operatorFront.id);
    });
    return operator;
  }
}
